import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { STATUS } from "../../constants/status";
//core imports
import SFProgressBar from "../../../components/progressBar";
import SFTypography from "../../../components/typography";
import SFDialog from "../../../components/dialog";

const UploadFileProgress = ({ fileStatus, onClose, open }) => {
  const { t } = useTranslation();

  return (
    <SFDialog
      title={t("fileUploadWizard.dialog.uploadingRows")}
      open={open}
      onClose={fileStatus.status === STATUS.FAILED ? onClose : null}
      primaryButton={fileStatus.status === STATUS.FAILED}
      primaryButtonProps={{
        onClick: onClose,
      }}
      // Uncomment when retry functionality is implemented
      // secondaryButton={fileStatus.status === STATUS.FAILED}
      // secondaryButtonProps={{
      //   label: t("fileUploadWizard.dialog.retryBtn"),
      //   onClick: () => {},
      // }}
    >
      <SFProgressBar
        failed={fileStatus.status === STATUS.FAILED}
        loadingText={
          <SFTypography variant="body1bold">
            {t("fileUploadWizard.dialog.progress")}
          </SFTypography>
        }
        variant={"indeterminate"}
      />
      {fileStatus.status === STATUS.FAILED && fileStatus.message && (
        <SFTypography variant="body1">{fileStatus.message}</SFTypography>
      )}
    </SFDialog>
  );
};

UploadFileProgress.propTypes = {
  open: PropTypes.bool.isRequired,
  fileStatus: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default UploadFileProgress;
